/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDev } from './FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDev';
import {
    FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevFromJSON,
    FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevFromJSONTyped,
    FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevToJSON,
    FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevToJSONTyped,
} from './FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDev';

/**
 * 
 * @export
 * @interface FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions
 */
export interface FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions {
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDev}
     * @memberof FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions
     */
    DevToDev?: FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDev | null;
}

/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions(value: object): value is FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions {
    return true;
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsFromJSON(json: any): FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions {
    return FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'DevToDev': json['DevToDev'] == null ? undefined : FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevFromJSON(json['DevToDev']),
    };
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsToJSON(json: any): FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions {
    return FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsToJSONTyped(value?: FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'DevToDev': FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevToJSON(value['DevToDev']),
    };
}

